import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import { PrismButton, PrismIcon } from '@mylighthouse/prism-ember';
// @ts-expect-error: Incorrect type
import stopPropagation from 'ember-event-helpers/helpers/stop-propagation';

import styles from './drag-item.module.css';

interface HotelNetRevenueCostDrilldownSectionTableLayoutDragItemSignature {
  Args: {
    isHidden: boolean;
    label: string;
    toggleVisible: () => void;
  };
  Element: HTMLLIElement;
}

const HotelNetRevenueCostDrilldownSectionTableLayoutDragItem = <template>
  <li
    class="{{styles.item}} {{if @isHidden styles.hidden}}"
    data-test-id="table-layout-drag-item"
    ...attributes
  >
    <span aria-hidden="true" class={{styles.handle}}>
      <PrismIcon @name="drag" @size="small" />
    </span>
    <span class="text-300--regular flex-1 truncate">{{@label}}</span>
    <PrismButton
      @buttonType="ghost"
      @icon={{if @isHidden "visibility-off" "visibility-on"}}
      @size="small"
      data-test-id="table-layout-drag-item-toggle"
      {{on "click" (stopPropagation @toggleVisible)}}
    />
  </li>
</template> satisfies TOC<HotelNetRevenueCostDrilldownSectionTableLayoutDragItemSignature>;

export default HotelNetRevenueCostDrilldownSectionTableLayoutDragItem;
